var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('b',[_vm._v("Заемщик")]),_vm._v(" "+_vm._s(_vm.LastName)+" "+_vm._s(_vm.FirstName)+" "+_vm._s(_vm.MiddleName)+" / "+_vm._s(_vm.DemandDate))]),_c('div',[_c('p',[_vm._v("Электронная подпись")]),_c('p',[_vm._v("Дата и время подписи: "+_vm._s(_vm._f("timeFromXtoDateView")(_vm.DataConfirm)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }